export default "__VITE_ASSET__a66cfcc7__"